<ng-container *appDesktop>
    <app-page-topbar
        *ngIf="assessment$ | async as assessment"
        [title]="assessment?.title">

        <ng-container *ngIf="(isAtLeastAdmin$ | async)">
            <ng-container *ngIf="!(isEdited$ | async); else closeEditor">
                <div
                    class="secondary-button"
                    [routerLink]="'/assessments/' + assessment?._id + '/edit/questionnaire'">
                    <app-custom-icon
                        [iconPath]="'assets/icons/general-icons.svg'"
                        [imageName]="'icon-cog'">
                    </app-custom-icon>
                    Settings
                </div>
            </ng-container>

            <ng-template #closeEditor>
                <div
                    class="secondary-button"
                    [routerLink]="'/assessments/' + assessment?._id">
                    <app-custom-icon
                        [iconPath]="'assets/icons/general-icons.svg'"
                        [imageName]="'icon-close'">
                    </app-custom-icon>
                    <ng-container *appDesktop>Settings</ng-container>
                </div>
            </ng-template>
        </ng-container>

        <p-button
            type="button"
            label="New Report"
            *appDesktop
            [disabled]="isEdited$ | async"
            (click)="openNewReport(assessment)">
        </p-button>

        <ng-container *appDesktop nav-tabs>
            @if (hasAccess$ | async) {
                @if (navTabs$ | async; as navTabs) {
                    <app-nav-tabs [navTabs]="navTabs"></app-nav-tabs>
                }
            }
        </ng-container>
    </app-page-topbar>
</ng-container>

<ng-container *appMobile>
    <div *ngIf="isEdited$ | async" class="editor-header" [routerLink]="'/assessments/' + (assessment$ | async)?._id">
        <app-custom-icon
            [iconPath]="'assets/icons/general-icons.svg'"
            [imageName]="'icon-close'">
        </app-custom-icon>
        <span>Form Settings</span>
    </div>
    <app-page-topbar
        *ngIf="assessment$ | async as assessment"
        [title]="(isEdited$ | async) ? (currentTab$ | async)?.label : assessment?.title"
        [subTitle]="(isEdited$ | async) ? 'Form: ' + assessment?.title : 'Forms'"
        [top]="(isEdited$ | async) ? '38px' : '0'"
        [menu]="navTabs$ | async">
        <ng-container *ngIf="!(isEdited$ | async) && (hasAccess$ | async)">
            <div
                class="secondary-button"
                [routerLink]="'/assessments/' + assessment?._id + '/edit/questionnaire'">
                <app-custom-icon
                    [iconPath]="'assets/icons/general-icons.svg'"
                    [imageName]="'icon-cog'">
                </app-custom-icon>
            </div>
        </ng-container>
    </app-page-topbar>
</ng-container>

@if (newReportSidebarVisible) {
    <app-flight-report-details
        [visible]="true"
        [assessmentId]="selectedAssessment?._id ?? null"
        [mode]="'create'"
        [returnTo]="'/home/tasks'"
        (closed)="newReportSidebarVisible = false">
    </app-flight-report-details>
}

<router-outlet></router-outlet>
